import React, { memo, useState, useImperativeHandle, forwardRef } from 'react'
import type { CustomCellEditorProps } from 'ag-grid-react'
import DimensionTreeSelect from '../../../../../features/dimension/components/DimensionTreeSelect'
import './DimensionTreeSelectEditor.css'

interface DimensionTreeSelectEditorParams {
  companyId?: string
}

/**
 * Custom Dimension Tree Select Cell Editor
 *
 * Provides a tree select editor for selecting dimensions in AG Grid cells
 * Requires companyId in cellEditorParams
 */
const DimensionTreeSelectEditor = memo(
  forwardRef<any, CustomCellEditorProps<any, string | undefined>>(
    ({ value, onValueChange, stopEditing, column }, ref) => {
      const [currentValue, setCurrentValue] = useState<string | undefined>(value ?? undefined)

      // Get companyId from cellEditorParams
      const params = (column?.getColDef()?.cellEditorParams || {}) as DimensionTreeSelectEditorParams
      const { companyId } = params

      const handleChange = (newValue: string | undefined) => {
        setCurrentValue(newValue)
        onValueChange(newValue)
        stopEditing()
      }

      useImperativeHandle(ref, () => ({
        getValue: () => currentValue
      }))

      return (
        <DimensionTreeSelect
          companyId={companyId}
          value={currentValue}
          onChange={handleChange}
          disabled={false}
          style={{ width: '100%', height: '100%' }}
          className="dimension-tree-select-editor"
        />
      )
    }
  )
)

DimensionTreeSelectEditor.displayName = 'DimensionTreeSelectEditor'

export default DimensionTreeSelectEditor
